export default __webpack_public_path__ + "img/mail.1c17af82.svg";